import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { domesticPaths, commercialPaths } from '../models/paths';

// Which half of the site the visitor is in ("domestic" or "commercial"), so
// shared pages (/about, /contact...) keep the matching menu and footer.
// The first render depends on the URL only, so it matches the prerendered
// HTML during hydration; the remembered choice is applied after mount.
const sectionFromPath = (pathname) => {
  const path = pathname.replace(/\/$/, '');
  if (domesticPaths.includes(path)) return 'domestic';
  if (commercialPaths.includes(path)) return 'commercial';
  return null;
};

export default function useServiceContext() {
  const { pathname } = useLocation();
  const section = sectionFromPath(pathname);
  const [stored, setStored] = useState(null);

  useEffect(() => {
    if (section) {
      sessionStorage.setItem('serviceContext', section);
      setStored(section);
    } else {
      setStored(sessionStorage.getItem('serviceContext'));
    }
  }, [section]);

  return section || stored || 'commercial';
}
